import { render, staticRenderFns } from "./institucion.vue?vue&type=template&id=e6e1c596&scoped=true&"
import script from "./institucion.component.ts?vue&type=script&lang=ts&"
export * from "./institucion.component.ts?vue&type=script&lang=ts&"
import style0 from "./institucion.vue?vue&type=style&index=0&id=e6e1c596&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e1c596",
  null
  
)

export default component.exports